// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"584ab4e4","169":"a67bbe94","437":"00c08016","472":"1f65718c","584":"0bf056b9","766":"c91d3dcb","858":"36399080"}[chunkId] + ".chunk.js";
};